const balance = {
    en: {
        "balance.title": "Balance requests",
        "balance.newRequest": "New request",
        "balance.amount": "Amount",
        "balance.note": "Note",
        "balance.submit": "Submit request",
        "balance.myRequests": "My requests",
        "balance.allRequests": "All requests",
        "balance.dealer": "Dealer",
        "balance.status": "Status",
        "balance.date": "Date",
        "balance.actions": "Actions",
        "balance.approve": "Approve",
        "balance.reject": "Reject",
        "balance.pending": "Pending",
        "balance.approved": "Approved",
        "balance.rejected": "Rejected",
        "balance.none": "No requests yet",
        "balance.reviewedBy": "Reviewed by",
    },
    ru: {
        "balance.title": "Запросы баланса",
        "balance.newRequest": "Новый запрос",
        "balance.amount": "Сумма",
        "balance.note": "Примечание",
        "balance.submit": "Отправить запрос",
        "balance.myRequests": "Мои запросы",
        "balance.allRequests": "Все запросы",
        "balance.dealer": "Дилер",
        "balance.status": "Статус",
        "balance.date": "Дата",
        "balance.actions": "Действия",
        "balance.approve": "Одобрить",
        "balance.reject": "Отклонить",
        "balance.pending": "В ожидании",
        "balance.approved": "Одобрено",
        "balance.rejected": "Отклонено",
        "balance.none": "Запросов пока нет",
        "balance.reviewedBy": "Обработал",
    },
    geo: {
        "balance.title": "ბალანსის მოთხოვნები",
        "balance.newRequest": "ახალი მოთხოვნა",
        "balance.amount": "თანხა",
        "balance.note": "შენიშვნა",
        "balance.submit": "მოთხოვნის გაგზავნა",
        "balance.myRequests": "ჩემი მოთხოვნები",
        "balance.allRequests": "ყველა მოთხოვნა",
        "balance.dealer": "დილერი",
        "balance.status": "სტატუსი",
        "balance.date": "თარიღი",
        "balance.actions": "მოქმედებები",
        "balance.approve": "დადასტურება",
        "balance.reject": "უარყოფა",
        "balance.pending": "მოლოდინში",
        "balance.approved": "დადასტურებული",
        "balance.rejected": "უარყოფილი",
        "balance.none": "მოთხოვნები ჯერ არ არის",
        "balance.reviewedBy": "დაამუშავა",
    },
};

export default balance;
